
import VehiclesContainer from "./VehiclesContainer";
import VehiclesStore from "./VehiclesStore";

export default VehiclesStore(VehiclesContainer);